import { Stack } from '@mui/material';
import { useNavigate } from 'react-router';
import { SubMenu } from 'src/compass/site/routes';
import CasLink from 'src/compass/shared/components/CasLink/CasLink';

type MenuPageLayoutProps = {
  subMenus: SubMenu[];
};

export default function MenuPageLayout({ subMenus }: MenuPageLayoutProps) {
  const navigate = useNavigate();

  return (
    <Stack gap="0.5rem">
      {subMenus.map(
        (subMenu) =>
          !subMenu.hidden && (
            <CasLink key={subMenu.title} onClick={() => navigate(subMenu.path)}>
              {subMenu.title}
            </CasLink>
          )
      )}
    </Stack>
  );
}
